import axios from 'axios'
import { useMutation } from '@percent/cause-dashboard/common/hooks'
import { useServices } from '@percent/cause-dashboard/context/serviceContext/ServiceContext'

export type UseCancelOpportunityProps = Readonly<{
  opportunityId: string
  onCancelled?: () => void
  onError: (error: Record<'code' | 'message' | 'title', string>) => void
}>

export type UseCancelOpportunityReturn = Readonly<{
  isLoading: boolean
  cancelOpportunity: () => void
}>

const defaultError = {
  code: 'error',
  message: 'error',
  title: 'error'
}

export const useCancelOpportunity = ({
  opportunityId,
  onCancelled,
  onError
}: UseCancelOpportunityProps): UseCancelOpportunityReturn => {
  const { volunteeringService } = useServices()

  const [{ isLoading }, { apiFunc: cancelOpportunity }] = useMutation(
    volunteeringService.cancelOpportunity,
    () => {
      onCancelled?.()
    },
    error => {
      const errorData = axios.isAxiosError(error) ? error.response?.data?.error : undefined
      onError(errorData ?? defaultError)
    }
  )

  return {
    isLoading,
    cancelOpportunity: () => {
      if (opportunityId) {
        cancelOpportunity(opportunityId)
      }
    }
  }
}
